/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Email_AddressInputs */

const en_admin_external_booking_edit_email_address = /** @type {(inputs: Admin_External_Booking_Edit_Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Email_AddressInputs) => LocalizedString} */
const de_admin_external_booking_edit_email_address = en_admin_external_booking_edit_email_address;

/** @type {(inputs: Admin_External_Booking_Edit_Email_AddressInputs) => LocalizedString} */
const es_admin_external_booking_edit_email_address = en_admin_external_booking_edit_email_address;

/** @type {(inputs: Admin_External_Booking_Edit_Email_AddressInputs) => LocalizedString} */
const fr_admin_external_booking_edit_email_address = en_admin_external_booking_edit_email_address;

/** @type {(inputs: Admin_External_Booking_Edit_Email_AddressInputs) => LocalizedString} */
const it_admin_external_booking_edit_email_address = en_admin_external_booking_edit_email_address;

/** @type {(inputs: Admin_External_Booking_Edit_Email_AddressInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_email_address = en_admin_external_booking_edit_email_address;

/** @type {(inputs: Admin_External_Booking_Edit_Email_AddressInputs) => LocalizedString} */
const pl_admin_external_booking_edit_email_address = en_admin_external_booking_edit_email_address;

/** @type {(inputs: Admin_External_Booking_Edit_Email_AddressInputs) => LocalizedString} */
const hu_admin_external_booking_edit_email_address = en_admin_external_booking_edit_email_address;

/** @type {(inputs: Admin_External_Booking_Edit_Email_AddressInputs) => LocalizedString} */
const ro_admin_external_booking_edit_email_address = en_admin_external_booking_edit_email_address;

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Admin_External_Booking_Edit_Email_AddressInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_email_address = /** @type {((inputs?: Admin_External_Booking_Edit_Email_AddressInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Email_AddressInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_email_address(inputs)
	if (locale === "de") return de_admin_external_booking_edit_email_address(inputs)
	if (locale === "es") return es_admin_external_booking_edit_email_address(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_email_address(inputs)
	if (locale === "it") return it_admin_external_booking_edit_email_address(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_email_address(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_email_address(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_email_address(inputs)
	return ro_admin_external_booking_edit_email_address(inputs)
});
export { admin_external_booking_edit_email_address as "admin.external_booking_edit.email_address" }